var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 6.253a.56.56 0 0 1-.562-.563V2.315a.561.561 0 1 1 1.125 0v1.877l.468-.55a5.25 5.25 0 1 1 .881 7.56.564.564 0 0 1 .675-.9 4.125 4.125 0 1 0-.694-5.94l-.002.006-.646.76H5.5a.561.561 0 1 1 0 1.125z"
  })));
};
export default SvgUndo;